import { render, staticRenderFns } from "./PageFeedback.vue?vue&type=template&id=50648ec6"
import script from "./PageFeedback.vue?vue&type=script&lang=js"
export * from "./PageFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports